// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `

.background {
  filter: blur(3px);
  position: absolute;
  z-index: -1;
}

.dialog-card {
  margin-bottom: 10px;
  border-radius: 7px;
  margin: 5px;
  padding: 10px;
  background-color: #fff;
  box-shadow: 0 2px 4px -1px rgba(0,0,0,0.2), 0 4px 5px 0 rgba(0,0,0,0.14), 0 1px 10px 0 rgba(0,0,0,0.12);
}
.measurement-dialog {
}
.map-button {
  position: absolute; z-index: 9999;
  background: white;
  border-radius: 50px;
  width: 25px; height: 25px;
  padding: 5px;
}
.asset-comment-input {
  width: 100%;
  padding: 9px;
  resize: none;
  border-color: #d5dce0;
  border-radius: 2px;
  outline: none;
}
    `, "",{"version":3,"sources":["webpack://./src/app/components/super-pro/super-pro.ts"],"names":[],"mappings":";;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,uGAAuG;AACzG;AACA;AACA;AACA;EACE,kBAAkB,EAAE,aAAa;EACjC,iBAAiB;EACjB,mBAAmB;EACnB,WAAW,EAAE,YAAY;EACzB,YAAY;AACd;AACA;EACE,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,qBAAqB;EACrB,kBAAkB;EAClB,aAAa;AACf","sourcesContent":["\n\n.background {\n  filter: blur(3px);\n  position: absolute;\n  z-index: -1;\n}\n\n.dialog-card {\n  margin-bottom: 10px;\n  border-radius: 7px;\n  margin: 5px;\n  padding: 10px;\n  background-color: #fff;\n  box-shadow: 0 2px 4px -1px rgba(0,0,0,0.2), 0 4px 5px 0 rgba(0,0,0,0.14), 0 1px 10px 0 rgba(0,0,0,0.12);\n}\n.measurement-dialog {\n}\n.map-button {\n  position: absolute; z-index: 9999;\n  background: white;\n  border-radius: 50px;\n  width: 25px; height: 25px;\n  padding: 5px;\n}\n.asset-comment-input {\n  width: 100%;\n  padding: 9px;\n  resize: none;\n  border-color: #d5dce0;\n  border-radius: 2px;\n  outline: none;\n}\n    "],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
